export enum ActionTypes {
  RESET_APP = 'app/RESET_APP',
  SET_READY = 'app/SET_READY',
  SET_MUST_UPDATE = 'app/MUST_UPDATE',
  SET_APP_VISIBILITY = 'app/SET_APP_VISIBILITY',
  MUST_UPDATE_POINTS = 'app/MUST_UPDATE_POINTS',
  MUST_UPDATE_SUMMARY = 'app/MUST_UPDATE_SUMMARY',
}

export interface State {
  ready: boolean;
  mustUpdate: boolean;
  appVisibility: string | null;
  mustUpdatePoints: boolean;
  mustUpdateSummary: boolean;
}

export interface ResetAppAction {
  type: ActionTypes.RESET_APP;
}
export interface SetReadyAction {
  type: ActionTypes.SET_READY;
  payload: boolean;
}
export interface MustUpdateAction {
  type: ActionTypes.SET_MUST_UPDATE;
  payload: boolean;
}
export interface SetAppVisibilityAction {
  type: ActionTypes.SET_APP_VISIBILITY;
  payload: string | null;
}
export interface MustUpdatePointsAction {
  type: ActionTypes.MUST_UPDATE_POINTS;
  payload: boolean;
}
export interface MustUpdateSummaryAction {
  type: ActionTypes.MUST_UPDATE_SUMMARY;
  payload: boolean;
}

export type ActionType =
  | ResetAppAction
  | SetReadyAction
  | MustUpdateAction
  | SetAppVisibilityAction
  | MustUpdatePointsAction
  | MustUpdateSummaryAction;
